import PropTypes from 'prop-types';
import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {GridList, GridTile} from 'material-ui/GridList';
import InfiniteGrid from 'shared/vendor/react-infinite-grid/src/grid';
import {
  selectImages,
  unselectImages,
  replaceSelectedImages,
  changeSearchFile,
  unselectAllImages,
  updateSearch,
  changeView,
} from 'MyAccount/ViewDesigns/redux/modules/images';
import {SORT_DIRECTION_DESC} from '../consts';
import * as Colors from 'material-ui/styles/colors';
import {getCurrentFolderImages, getSelectedImages, isTrashFolder} from '../selectors';
import AssetsImage, {SELECTION_TYPES} from './AssetsImage/AssetsImage';
import SortBlock from './SortBlock';
import {keymaster, pushScope, popScope} from 'shared/helpers/keymasterHelper';
import Dimensions from 'react-dimensions';
import {CONTENT_PADDING_TOP, CONTENT_PADDING_LEFT, IMAGE_PADDING, VIEW_LIST, VIEW_GRID, TRASH_FOLDER} from '../consts';
import ListView from './ListView';
import IconButton from 'material-ui/IconButton';
import ViewListIcon from 'material-ui/svg-icons/action/view-list';
import ViewGridIcon from '../icons/ViewGridIcon';
import {setWindowBusy} from 'MyAccount/ViewDesigns/redux/modules/general';
import {openLazyPanel} from 'crazyEditor/redux/modules/panel/panel';
import {PANELS} from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import {DELETE_IMAGE_DIALOG} from '../consts';
import {openDialog} from '../helpers';
import {TemplatesEmptyState} from 'MyAccount/ViewTemplates/containers/EmptyState';
import EmptyState from '../../../ViewTemplates/containers/EmptyState';

const SCOPE_NAME = 'imagesContent';

@connect(
  (state, props) => ({
    photos: getCurrentFolderImages(state, props),
    selectedImages: getSelectedImages(state),
    searchFile: state.images.Images.searchFile,
    search: state.images.Images.search,
    sort: state.images[props.resourceType].sort,
    view: state.images[props.resourceType].view || VIEW_GRID,
    isTrashFolder: isTrashFolder(props.currentFolder),
  }),
  {
    selectImages,
    unselectImages,
    replaceSelectedImages,
    changeSearchFile,
    unselectAllImages,
    updateSearch,
    changeView,
    setWindowBusy,
    openLazyPanel,
  },
  false,
  {forwardRef: true}
)
class ImagesContent extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.props.unselectAllImages();
    pushScope(SCOPE_NAME);
  }

  componentDidMount() {
    keymaster('ctrl+a, ctrl, shift', SCOPE_NAME, this._handleKeyPress);
  }

  componentWillUnmount() {
    this.props.updateSearch({search: ''});
    keymaster.deleteScope(SCOPE_NAME);
    popScope();
  }

  getSortFields = ['date', 'name', 'size'];

  getSortFunction(sortField) {
    switch (sortField) {
      case this.getSortFields[1]:
        return ({name}) => name.toLowerCase().trim();
      default:
        return sortField;
    }
  }

  getRootStyle() {
    return {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      flex: 1,
      height: `calc(100% - ${this.getContentPaddingTop()}px)`,
      margin: `${this.getContentPaddingTop()}px 0px 0px 0px`,
      position: 'relative',
    };
  }

  getContentPaddingTop() {
    const {view} = this.props;
    return view === VIEW_GRID ? CONTENT_PADDING_TOP : 0;
  }

  getItems(photos) {
    const {selectedImages, currentFolder, resourceType, integrated, sort, view, isTrashFolder} = this.props;
    const sortField = sort.field || this.getSortFields[0];
    const sortDirection = sort.direction || SORT_DIRECTION_DESC;
    const sortedPhotos = _.orderBy(photos, this.getSortFunction(sortField), sortDirection);
    const showRestoreFromTrashButton = resourceType !== 'Icons' && isTrashFolder;
    // const showCropAndEditButton = resourceType !== 'Icons' && !isTrashFolder;
    const showDeleteButton = resourceType !== 'Icons' && isTrashFolder;
    return sortedPhotos.map((item, index) => {
      const imgPath = `${item.path}${item.name}`;
      const isSelected = !!selectedImages[imgPath];
      return view === VIEW_GRID ? (
        <AssetsImage
          selected={isSelected}
          currentFolder={currentFolder}
          item={item}
          resourceType={resourceType}
          showCheckbox={resourceType !== 'Icons'}
          key={imgPath}
          innerkey={imgPath}
          onSelect={(item, selectionType) =>
            this._handleImgClick(imgPath, index, sortedPhotos, isSelected, selectionType)
          }
          integrated={integrated}
          imageSize="100%"
          onRestoreFromTrashButtonClick={showRestoreFromTrashButton ? this.restoreFromTrash : undefined}
          // onCropAndEditButtonClick={showCropAndEditButton ? this.openFeatherEditor : undefined}
          imageDropDownFunctions={showDeleteButton ? undefined : {}} // TODO make ImageDropDownMenu a presentational component
          onDeleteButtonClick={showDeleteButton ? () => this.openDeleteImageDialog(imgPath) : undefined}
        />
      ) : (
        {
          ...item,
          id: imgPath,
          select: imgPath,
        }
      );
    });
  }

  getImageSize = (containerWidth, IMAGE_PADDING) => {
    let imageSize = _.round(containerWidth / this.getItemsPerRow(containerWidth)) - IMAGE_PADDING;
    if (imageSize < 155) imageSize = 155;
    if (imageSize > 200) imageSize = 200;
    return imageSize;
  };

  getItemsPerRow = containerWidth => {
    let itemsPerRowLimit = 1;
    if (containerWidth < 720) itemsPerRowLimit = 3;
    if (containerWidth >= 720 && containerWidth < 895) itemsPerRowLimit = 4;
    if (containerWidth >= 895 && containerWidth < 1070) itemsPerRowLimit = 5;
    if (containerWidth >= 1070 && containerWidth < 1245) itemsPerRowLimit = 6;
    if (containerWidth >= 1245 && containerWidth < 1420) itemsPerRowLimit = 7;
    if (containerWidth >= 1420) itemsPerRowLimit = 8;
    return itemsPerRowLimit;
  };

  getSearchItemIndex() {
    const {photos, searchFile} = this.props;
    return _.findIndex(photos, photo => {
      return `${photo.path}${photo.name}` === searchFile;
    });
  }

  setSelectedItemIds = ids => this.props.replaceSelectedImages(_.keys(_.pickBy(ids, value => value)));

  openDeleteImageDialog = innerkey => {
    this.toggleIconMenu(false);
    const {integrated, openLazyPanel} = this.props;
    if (integrated) {
      openLazyPanel(PANELS.DELETE_IMAGE, null, null, {images: innerkey});
    } else {
      openDialog({
        dialogName: DELETE_IMAGE_DIALOG,
        images: [innerkey],
      });
    }
  };

  restoreFromTrash = item => {
    const {currentFolder, setWindowBusy} = this.props;
    setWindowBusy(true);
    const fixedCurrentFolder = _.replace(currentFolder, /\\/gi, '/');
    const files = [
      {
        options: 'autorename',
        name: item.name,
        type: 'Images',
        folder: currentFolder ? `/${fixedCurrentFolder}/` : '/',
      },
    ];
    this.context.imageUtils.doRestoreFromTrash(
      {
        files,
      },
      () => {
        setWindowBusy(false);
      }
    );
  };

  noImagesFound(search) {
    const {view} = this.props;
    return (
      <div style={{marginTop: `${view !== VIEW_GRID ? CONTENT_PADDING_TOP : 0}`}}>
        <p
          style={{fontSize: 24, color: Colors.grey700}}
        >{`Well, no image turning up for "${search}" in your folders`}</p>
        <p style={{fontSize: 18}}>Try using another search term</p>
      </div>
    );
  }

  lastCheckedImage = '';
  lastCheckedImageIndex = 0;

  _handleKeyPress = (event, keyMasterEvent) => {
    const {photos, replaceSelectedImages, type} = this.props;
    event.preventDefault();
    switch (keyMasterEvent.key) {
      case 'ctrl+a':
        if (type !== 'icons') {
          replaceSelectedImages(_.map(photos, photo => photo.path + photo.name));
        }
        break;
      default:
        break;
    }
  };

  _handleCheckImage = (imgPath, index, sortedPhotos, selected) => {
    if (selected) {
      this.props.unselectImages(imgPath);
    } else {
      this.props.selectImages(imgPath);
    }
    this.lastCheckedImage = imgPath;
    this.lastCheckedImageIndex = index;
  };

  _handleShiftPlusClick = (index, sortedPhotos) => {
    const {replaceSelectedImages, selectedImages} = this.props;
    const lastIndex = _.size(selectedImages) ? this.lastCheckedImageIndex : 0;
    const files = _.map(sortedPhotos, photo => photo.path + photo.name);
    const min = _.min([index, lastIndex]);
    const max = _.max([index, lastIndex]);
    replaceSelectedImages(
      _.filter(files, (file, number) => {
        return _.inRange(number, min, max + 1); // + 1 for include last image into selection
      })
    );
  };

  _handleImgClick = (imgPath, index, sortedPhotos, selected, selectionType) => {
    const {type} = this.props;
    if (type === 'icons') {
      this.props.replaceSelectedImages(imgPath);
    } else {
      switch (selectionType) {
        case SELECTION_TYPES.CTRL_SELECTION:
          this._handleCheckImage(imgPath, index, null, selected);
          break;
        case SELECTION_TYPES.SHIFT_SELECTION:
        case SELECTION_TYPES.CTRL_AND_SHIFT_SELECTION:
          this._handleShiftPlusClick(index, sortedPhotos);
          break;
        case SELECTION_TYPES.REGULAR_SELECTION:
        default:
          if (type === 'gallery') {
            this._handleCheckImage(imgPath, index, null, selected);
          } else {
            this.props.replaceSelectedImages(imgPath);
          }
          break;
      }
    }
    this.lastCheckedImage = imgPath;
    this.lastCheckedImageIndex = index;
  };

  unselectAllImages = () => {
    this.props.unselectAllImages();
  };

  noImagesInFolder = search => {
    if (search) {
      return this.noImagesFound(search);
    }
    const {isTrashFolder} = this.props;
    return isTrashFolder ? (
      <EmptyState
        headline="Trash Folder Is Empty"
        src="monster_pink"
        paragraphs={['There are no deleted images here', 'When you delete an image it goes here, to the Trash folder']}
      />
    ) : (
      <EmptyState
        headline="This Folder Is Empty"
        src="no_images_new"
        paragraphs={['Click “UPLOAD IMAGES” to upload images from your computer to this folder']}
      />
    );
  };

  searchFile(filename, search) {
    filename = _.toLower(filename);
    search = _.toLower(search);
    if (_.size(search) > _.size(filename)) {
      return false;
    }
    let fileFound = false;
    _.map(filename, (file, i) => {
      if (filename[i] === search[0]) {
        let success = 0;
        _.map(search, (item, index) => {
          if (item === filename[i + index]) {
            success += 1;
          }
        });
        if (!fileFound) {
          fileFound = success === _.size(search);
        }
      }
    });
    return fileFound;
  }

  render() {
    const {
      currentFolder,
      changeSearchFile,
      search,
      resourceType,
      view,
      changeView,
      integrated,
      setWindowBusy,
      openLazyPanel,
    } = this.props;
    let photos = this.props.photos;
    if (search) {
      photos = _.filter(photos, photo => this.searchFile(photo.name, search));
    }
    return _.isEmpty(photos) ? (
      this.noImagesInFolder(search)
    ) : (
      <div style={this.getRootStyle()} onClick={this.unselectAllImages}>
        <SortBlock
          height={CONTENT_PADDING_TOP}
          paddingTop={this.getContentPaddingTop()}
          sortFields={this.getSortFields}
          resourceType={resourceType}
        />
        <IconButton
          style={{
            position: 'absolute',
            top: -this.getContentPaddingTop() + 2,
            right: 5,
            zIndex: 3,
            transition: 'none',
          }}
          onClick={() => changeView({view: view === VIEW_GRID ? VIEW_LIST : VIEW_GRID, resourceType})}
        >
          {view === VIEW_GRID ? <ViewListIcon /> : <ViewGridIcon />}
        </IconButton>
        {view === VIEW_GRID
          ? photos.length > 0 && (
              <InfiniteGrid
                entries={this.getItems(photos)}
                ref="grid"
                key={`${currentFolder}${photos.length}`}
                buffer={20}
                width={this.getImageSize(this.props.containerWidth - CONTENT_PADDING_LEFT, IMAGE_PADDING)}
                height={this.getImageSize(this.props.containerWidth - CONTENT_PADDING_LEFT, IMAGE_PADDING)}
                padding={IMAGE_PADDING}
                marginBottom={60}
                marginTop={0}
                itemsPerRowLimit={this.getItemsPerRow(this.props.containerWidth - CONTENT_PADDING_LEFT)}
                searchItemIndex={this.getSearchItemIndex()}
                changeSearchFile={changeSearchFile}
                getItemsPerRow={this.getItemsPerRow}
                getImageSize={this.getImageSize}
                containerWidth={this.props.containerWidth - CONTENT_PADDING_LEFT}
                constPadding
              />
            )
          : photos.length > 0 && (
              <ListView
                items={this.getItems(photos)}
                key={currentFolder}
                selectable
                showHeader
                hideSortBlock
                selectedItemIds={this.props.selectedImages}
                setSelectedItemIds={this.setSelectedItemIds}
                currentFolder={currentFolder}
                resourceType={resourceType}
                integrated={integrated}
                setWindowBusy={setWindowBusy}
                openLazyPanel={openLazyPanel}
              />
            )}
      </div>
    );
  }
}

export default Dimensions({elementResize: true})(ImagesContent);

ImagesContent.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  openDialog: PropTypes.func,
};
